/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-13 19:28:40
 * @Description: ugc稿件管理
 */
"use strict";
angular.module("pgcManageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage.pgcmanage", {
        url: "/pgcmanage",
        views: {
            "":{
                template:'<div class="pgcmanage" ui-veiw="main"></div>',
            }
        }
    }).state("backstage.pgcmanage.reviewmanuscript", {
        url: "/reviewmanuscript",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/reviewManuscript/reviewManuscript_tpl.html',
                controller:'reviewManuscriptCtrl'
            }
        }
    }).state("backstage.pgcmanage.hasbeen", {
        url: "/hasbeen",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/hasBeen/hasBeen_tpl.html',
                controller:'hasBeenCtrl'
            }
        }
    }).state("backstage.pgcmanage.channelmanagement", {
        url: "/channelmanagement",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/channelManagement/channelManagement_tpl.html',
                controller:'channelManagementCtrl'
            }
        }
    }).state("backstage.pgcmanage.labelmanagement", {
        url: "/labelmanagement",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/labelManagement/labelManagement_tpl.html',
                controller:'labelManagementCtrl'
            }
        }
    }).state("backstage.pgcmanage.labelmanagement.firstlevellabel", {
        url: "/firstlevellabel?channelId&channelName",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/labelManagement/firstLevelLabel/firstLevelLabel_tpl.html',
                controller:'firstLevelLabelCtrl'
            }
        }
    }).state("backstage.pgcmanage.labelmanagement.twolevellabel", {
        url: "/twolevellabel?parentId&channelId&tagName&channelName",
        views: {
            "main@backstage":{
                templateUrl:'./main/backstage/pgcManage/labelManagement/twoLevelLabel/twoLevelLabel_tpl.html',
                controller:'twoLevelLabelCtrl'
            }
        }
    });
}]);